import StoreLogo from '@cohort/components-xps/components/navbar/StoreLogo';
import {useCurrentMerchant} from '@cohort/merchants/hooks/contexts/currentMerchant';
import {cn} from '@cohort/shared-frontend/utils/classNames';
import {useTranslation} from 'react-i18next';

type PreviewNavBarProps = {
  hasDarkBg: boolean;
  isMobile?: boolean;
};

const PreviewNavBar: React.FC<PreviewNavBarProps> = ({hasDarkBg}) => {
  const merchant = useCurrentMerchant();
  const {name: merchantName, logoFileKey} = merchant;
  const {t} = useTranslation('components', {
    keyPrefix: 'campaigns.preview.navbar',
  });

  return (
    <div
      className={cn(
        'flex items-center border-b px-4 py-3',
        hasDarkBg ? 'border-white/20 text-white' : 'border-black/20 text-black/90'
      )}
    >
      <StoreLogo logoImageFileKey={logoFileKey} name={merchantName} hasDarkBg={hasDarkBg} />
      <p
        className={cn(
          'mr-1.5 line-clamp-2 text-left text-base font-medium',
          hasDarkBg ? 'text-white' : 'text-black/90'
        )}
      >
        {t('experienceStore', {name: merchant.name})}
      </p>
    </div>
  );
};

export default PreviewNavBar;
